import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.scss';
import { createBrowserRouter, Link, NavLink, Outlet, RouterProvider, useLocation } from "react-router-dom";
import LoginPage from "./login/LoginPage";
import GroupPage from "./content/GroupPage";
import PackagePage from "./package/PackagePage";
import TagsPage from "./tags/TagsPage";
import DrillFilesPage from "./files/DrillFilesPage";
import DrillPage from "./files/DrillPage";
import UsersPage from "./users/UsersPage";
import UserPage from "./users/UserPage";
import { AuthProvider, useAuth } from "./auth-context";
import { ToastContainer } from "react-toastify";

import 'react-toastify/dist/ReactToastify.css';
import { ApiProvider } from "./api-context";

const Layout = () => {
    const { pathname } = useLocation();
    const { data, setToken } = useAuth();

    return (
        <ApiProvider>
            {
                pathname.includes('login') ? null : (
                    <div style={{
                        backgroundColor: 'black',
                        display: 'flex',
                        padding: '20px 24px',
                        gap: '24px'
                    }}>
                        <div style={{
                            color: 'white',
                            lineHeight: '16px',
                            fontSize: '15px',
                            fontFamily: 'InterRegular'
                        }}>
                            HCV Portal for: <span style={{fontFamily: 'InterSemiBold'}}>{data?.organisationName?.toUpperCase()}</span>
                        </div>
                        {
                            data?.memberType === 'ADMIN' ? (
                                <NavLink
                                    className={({ isActive, isPending }) =>
                                        isPending ? "pending" : isActive ? "active" : ""
                                    }
                                    style={{
                                    color: 'white',
                                    lineHeight: '16px',
                                    fontSize: '15px'
                                }} to="/users">Users</NavLink>
                            ) : null
                        }
                        <NavLink
                            className={({ isActive, isPending }) =>
                                isPending ? "pending" : isActive ? "active" : ""
                            }
                            style={{
                            color: 'white',
                            lineHeight: '16px',
                            fontSize: '15px'
                        }} to="/files">Files</NavLink>
                        <NavLink
                            className={({ isActive, isPending }) =>
                                isPending ? "pending" : isActive ? "active" : ""
                            }
                            style={{
                            color: 'white',
                            lineHeight: '16px',
                            fontSize: '15px'
                        }} to="/group/0">Package list</NavLink>
                        <NavLink
                            className={({ isActive, isPending }) =>
                                isPending ? "pending" : isActive ? "active" : ""
                            }
                            style={{
                            color: 'white',
                            lineHeight: '16px',
                            fontSize: '15px'
                        }} to="/tags">Tags</NavLink>
                        <Link style={{
                            color: 'white',
                            lineHeight: '16px',
                            fontSize: '15px',
                            marginLeft: 'auto'
                        }} onClick={() => {
                            setToken('');
                        }} to="/login">Logout</Link>
                    </div>
                )
            }
            <Outlet />
        </ApiProvider>
    );
};

const router = createBrowserRouter([{
    element: <Layout/>,
    children: [
        {
            path: "/",
            element: <GroupPage/>,
        },
        {
            path: "/tags",
            element: <TagsPage/>,
        },
        {
            path: "/files",
            element: <DrillFilesPage/>,
        },
        {
            path: "/users",
            element: <UsersPage/>,
        },
        {
            path: "/user/:id",
            element: <UserPage/>,
        },
        {
            path: "/file/:id",
            element: <DrillPage/>,
        },
        {
            path: "/group/:id",
            element: <GroupPage/>,
        },
        {
            path: "/package/:id",
            element: <PackagePage/>,
        },
        {
            path: "login",
            element: <LoginPage/>,
        },
    ]
}]);

ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
).render(
    <AuthProvider>
        <RouterProvider router={router} />
        <ToastContainer
            position="bottom-left"
            autoClose={7000}
            theme="colored"
            hideProgressBar={false}
            closeOnClick
            pauseOnHover
        />
    </AuthProvider>
);
